<template>
  <div v-if="loading_page === true">
    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else class="grid_row">
    <v-form ref="po_list" @submit.prevent="create_po">
      <v-card>
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
          <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
        </v-slide-x-reverse-transition>
        <div class="grid_half">
          <div class="grid_list pa-4">
            <div class="mt-1">
              <div class="ml-1 mr-1">
                <p>เลขที่เอกสาร : <b> {{ send_po_receipt.doc_number || '-' }} </b></p>
              </div>
            </div>
            <div class="mt-1">
              <div class="mr-1">
                <!-- <p>PO20250627001</p> -->
              </div>
            </div>
            <div class="mt-3 mr-1">
              <v-autocomplete color="#86bc3a" :items="po_lists" item-text="po_code" item-value="po_id"
                @change="getPO_lists(send_po_receipt.po_lists_id)" v-model="send_po_receipt.po_lists_id"
                prepend-inner-icon="mdi-file-compare" label="เลขที่/PO No." hide-details="auto"
                outlined></v-autocomplete>
            </div>
            <div class="mt-3 mr-1">
              <v-text-field color="#86bc3a" label="เลขที่ใบเสร็จ" :rules="[(v) => !!v || 'กรุณากรอกเลขที่ใบเสร็จ']"
                prepend-inner-icon="mdi-file-compare" hide-details="auto" v-model="send_po_receipt.receipt"
                outlined></v-text-field>
            </div>

            <div class="mt-5 mr-1 pl-1">
              <v-autocomplete color="#86bc3a" :items="supplierType" item-text="name" item-value="id"
                v-model="send_po_receipt.supplier_id" @change="onSupplierChange" prepend-inner-icon="mdi-domain"
                label="ชื่อ บริษัท/Supplier Name" hide-details="auto" outlined></v-autocomplete>

              <!-- <div>ชื่อ บริษัท/Supplier Name</div>
                <div class="pl-3 pt-1 grey--text">
                  {{ send_po_receipt.supplier_name }}
                </div> -->
              <!--              <v-text-field color="#86bc3a" label="ชื่อบริษัท/Supplier Name" prepend-inner-icon="mdi-domain" hide-details="auto" required v-model="send_po_receipt.supplier_name" outlined></v-text-field>-->
            </div>
            <div class="mt-5">
              <div class="mr-1">
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                  :return-value.sync="send_po_receipt.po_date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" v-model="send_po_receipt.po_date" label="วันที่ใบเสร็จ (วัน/เดือน/ปี)"
                      :rules="[(v) => !!v || 'กรุณากรอกวันที่ใบเสร็จ']" prepend-inner-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" :max="start_date"
                    v-model="dateEN" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>


          </div>
          <div class="pa-4">
            <span>ภาษีการซื้อ</span>
            <v-radio-group v-model="send_po_receipt.type_vat" mandatory>
              <div class="d-flex justify-space-around">
                <div class="d-flex ml-5">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>ภาษีรวมใน</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>ภาษีแยกนอก</div>
                </div>
              </div>
              <div class="d-flex justify-space-around mt-6">
                <div class="d-flex" style="margin-left: 3px">
                  <div>
                    <v-radio color="#86bc3a" :value="2"></v-radio>
                  </div>
                  <div>ไม่กระทบภาษี</div>
                </div>
                <div class="d-flex ml-n12">
                  <div>
                    <v-radio color="#86bc3a" :value="3"></v-radio>
                  </div>
                  <div>ภาษีเป็น 0</div>
                </div>
              </div>
            </v-radio-group>
          </div>
        </div>
        <div class="grid_half">
          <div v-if="send_po_receipt.po_type === 1">
            <div class="grid_list pa-4">
              <div class="mt-3 mr-1">
                <v-menu ref="menu_due_date" v-model="menu_due_date" :close-on-content-click="false"
                  :return-value.sync="send_po_receipt.date_credit" transition="scale-transition" offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" v-model="send_po_receipt.date_credit"
                      label="วันที่ครบกำหนด(วัน/เดือน/ปี)" :rules="[(v) => !!v || 'กรุณากรอกวันที่ครบกำหนด']"
                      prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDueDateTH(dateDueEN)" :min="start_date"
                    v-model="dateDueEN" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDueDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_due_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div v-else></div>
          <div class="pa-4">
            <span>ประเภท</span>
            <v-radio-group v-model="send_po_receipt.po_type" mandatory>
              <div class="d-flex justify-space-around">
                <div class="d-flex ml-n4">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>เงินสด</div>
                </div>
                <div class="d-flex ml-n12">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>เครดิต</div>
                </div>
              </div>
            </v-radio-group>
          </div>
        </div>
        <div class="grid_full">
          <div class="grid_product pa-4">
            <div v-if="this.data_list.length > 0" class="d_flex">
              <v-autocomplete color="#86bc3a" clearable :items="product_list" :item-text="displayProduct"
                item-value="product_id" v-model="send_po_receipt.pro_id" prepend-inner-icon="mdi-flask-plus-outline"
                label="สินค้า" hide-details="auto" outlined></v-autocomplete>
              <v-btn v-if="send_po_receipt.pro_id != null"
                class="ml-2 pa-7 mr-4 grad-success-bg white--text width_mobile"
                @click="add_product(send_po_receipt.pro_id)">เพิ่มสินค้า</v-btn>
              <v-btn v-if="send_po_receipt.pro_id == null" class="ml-2 pa-7 mr-4 grad-grey-bg width_mobile"
                disabled>เพิ่มสินค้า</v-btn>
            </div>
          </div>
        </div>
      </v-card>
      <v-card>
        <div class="pa-2 mt-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="Po_List" :items="data_list" key="index" item-key="product_code" :search="search"
            mobile-breakpoint="0" hide-default-footer :items-per-page="100">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.index + 1 }}</td>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>
                  <v-text-field color="#86bc3a" label="ล็อต" hide-details="auto" v-model="dataDetail.item.product_lot"
                    outlined></v-text-field>
                </td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>
                  <v-select color="#86bc3a" :items="dataDetail.item.units" placeholder="กรุณาเลือก"
                    :rules="[(v) => !!v || 'กรุณาเลือก']" item-text="unit_name" item-value="unit_id" hide-details="auto"
                    v-model="dataDetail.item.unit_id" outlined />
                </td>
                <td>
                  <!-- :disabled-date="notBeforeToday" -->
                  <date-picker clearable class="input_style" value-type="format" :formatter="format"
                    v-model="dataDetail.item.date_exp" :placeholder="dataDetail.item.date_exp" />
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number" @keypress="isOnlyNumber($event)" label="จำนวนที่ได้รับ"
                    :rules="[(v) => !!v || 'กรุณากรอกจำนวนที่ได้รับ']" hide-details="auto" min="0"
                    v-model="dataDetail.item.qty" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number" @keypress="isCurrency($event, dataDetail.item.price)"
                    label="ราคาต่อหน่วย" :rules="[(v) => (v === 0 || v === '0' || (v !== null && v !== undefined && v !== '')) || 'กรุณากรอกราคาต่อหน่วย']" hide-details="auto" min="0"
                    v-model="dataDetail.item.price" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number" @keypress="
                    isCurrency($event, dataDetail.item.discount_unit_price)
                    " label="ส่วนลด(บาท)" hide-details="auto" min="0" v-model="dataDetail.item.discount_unit_price"
                    outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number" @keypress="
                    isCurrency($event, dataDetail.item.discount_unit_percent)
                    " label="ส่วนลด(%)" hide-details="auto" min="0" v-model="dataDetail.item.discount_unit_percent"
                    outlined></v-text-field>
                </td>
                <td>
                  {{
                    format_price(
                      (dataDetail.item.total_price =
                        (dataDetail.item.price -
                          (dataDetail.item.price *
                            dataDetail.item.discount_unit_percent) /
                          100) *
                        dataDetail.item.qty -
                        dataDetail.item.discount_unit_price)
                    )
                  }}
                </td>
                <td>
                  <div class="v-input__slot">
                    <v-checkbox color="#86bc3a" v-model="dataDetail.item.status_return" />
                  </div>
                </td>
                <td class="pa-3">
                  <v-btn small height="42" @click="
                    getDelete(
                      dataDetail.item.loop_id,
                      dataDetail.item.po_lists_id
                    )
                    " class="grad-danger-bg white--text mb-1">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="8" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">รวม</div>
                  </div>
                </td>
                <td colspan="5" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">
                      {{ (send_po_receipt.sub_total = total) }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>ส่วนลดท้ายบิล (%)</div>
                  </div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>
                      <v-text-field color="#86bc3a" type="number" label="ส่วนลดท้ายบิล (%)" @keypress="
                        isCurrency(
                          $event,
                          send_po_receipt.discount_last_percent
                        )
                        " hide-details="auto" min="0" v-model="send_po_receipt.discount_last_percent"
                        outlined></v-text-field>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>ส่วนลดท้ายบิล (หน่วย)</div>
                  </div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>
                      <v-text-field color="#86bc3a" type="number" label="ส่วนลดท้ายบิล (หน่วย)" @keypress="
                        isCurrency(
                          $event,
                          send_po_receipt.discount_last_price
                        )
                        " hide-details="auto" min="0" v-model="send_po_receipt.discount_last_price"
                        outlined></v-text-field>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="border_col">
                  <div class="ml-2 mb-7">ราคาสินค้าไม่รวมภาษี</div>
                  <div class="ml-2 pt-1">ภาษีมูลค่าเพิ่ม 7%</div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4 text-center">
                    {{ (send_po_receipt.product_no_vat = no_vat) }}
                  </div>
                  <v-divider />
                  <div class="ma-4 text-center">
                    {{ (send_po_receipt.product_add_vat = cal_vat) }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>จำนวนเงินทั้งสิ้นรวมภาษี</div>
                  </div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4">
                    <!-- <div class="text-center">{{ format_price(send_po_receipt.grand_total = (total_all - send_po_receipt.discount_last_price)) }}</div> -->
                    <div class="text-center">
                      {{ (send_po_receipt.grand_total = total_all) }}
                    </div>
                  </div>
                </td>
              </tr>
              <v-divider />
            </template>
          </v-data-table>
          <div class="pa-4">
            <div class="mb-4">หมายเหตุ</div>
            <v-textarea color="#86bc3a" label="กรุณากรอกหมายเหตุ" v-model="send_po_receipt.note" outlined></v-textarea>
          </div>
        </div>
        <div class="pa-6 text-right">
          <v-btn x-large type="submit" class="grad-success-bg white--text" style="font-size: 18px">บันทึกข้อมูล</v-btn>
        </div>
      </v-card>
    </v-form>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import {
  formatPrice,
  minDate,
  onlyForCurrency,
  onlyForNumber,
} from "@/js/handler";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  components: {
    DatePicker,
  },
  name: "StoragePO",
  data() {
    return {
      date: "",
      dateEN: "",
      dateDueEN: "",
      overlay: false,
      menu_date: false,
      menu_due_date: false,
      loading_page: false,
      start_date: this.min_date(),
      search: null,
      name: null,
      alert_success: false,
      alert_danger: false,
      supplierType: [],
      format: {
        stringify: (date) => {
          const date_moment = moment(date).format("DD-MM-YYYY");
          const diff = date_moment.split("-");
          const day = diff[0];
          const month = diff[1];
          // const year = parseInt(diff[2])+ 543
          const year = parseInt(diff[2]);
          return day + "-" + month + "-" + year;
        },
      },
      product_list: [],
      product_lists: [],
      data_list: this.$store.state.data_frozen,
      po_id: 0,
      Po_List: [
        {
          text: "ลำดับ",
          value: "loop_id",
          fixed: true,
          width: "100px",
        },
        {
          text: "รหัสสินค้า",
          value: "product_code",
          fixed: true,
          width: "125px",
        },
        {
          text: "ล็อต",
          value: "product_lot",
          fixed: true,
          width: "170px",
        },
        {
          text: "รายการสินค้า",
          value: "product_name",
          fixed: true,
          width: "250px",
        },
        {
          text: "หน่วยนับ",
          value: "units",
          fixed: true,
          width: "180px",
        },
        {
          text: "วันที่หมดอายุ",
          value: "date_exp",
          fixed: true,
          width: "200px",
        },
        {
          text: "จำนวนที่ได้รับ",
          value: "qty",
          fixed: true,
          width: "150px",
        },
        {
          text: "ราคาต่อหน่วย",
          value: "price",
          fixed: true,
          width: "150px",
        },
        {
          text: "ส่วนลด(บาท)",
          value: "discount_unit",
          fixed: true,
          width: "150px",
        },
        {
          text: "ส่วนลด(%)",
          value: "discount",
          fixed: true,
          width: "150px",
        },
        {
          text: "ราคารวม",
          value: "total",
          sortable: false,
          fixed: true,
          width: "100px",
        },
        {
          text: "สินค้ารอคืน",
          value: "status_return",
          sortable: false,
          fixed: true,
          width: "120px",
        },
        {
          text: "ลบ",
          value: "action",
          sortable: false,
          fixed: true,
          width: "50px",
        },
      ],
      po_lists: [],
      po_data_list: [],
      loop_id: 0,
      send_po_receipt: {
        doc_number: null,
        po_lists_id: null,
        receipt: null,
        type_vat: 1,
        supplier_id: null,
        supplier_name: null,
        po_date: "",
        date_credit: "",
        po_type: null,
        note: null,
        product_no_vat: 0,
        product_add_vat: 0,
        discount_last_percent: 0,
        discount_last_price: 0,
        grand_total: 0,
        sub_total: 0,
      },
    };
  },
  methods: {
    onSupplierChange(id) {
      const selected = this.supplierType.find(sup => sup.id === id);
      this.send_po_receipt.supplier_name = selected ? selected.name : '';
    },
    displayProduct(item) {
      if (!item) return '';
      return `${item.barcode} - ${item.name} `;
    },
    cache_page() {
      window.addEventListener("beforeunload", function (event) {
        event.preventDefault();
        event.returnValue = "";
      });
    },
    un_reloadPage() {
      Swal.fire({
        title: "กรุณาตรวจสอบจำนวนให้ตรงกับใบสั่งซื้อ",
        icon: "error",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      });
    },
    async selectDate() {
      this.$refs.menu_date.save(this.send_po_receipt.po_date);
      this.menu_date = false;
    },
    async selectDueDate() {
      this.$refs.menu_due_date.save(this.send_po_receipt.date_credit);
      this.menu_due_date = false;
    },
    date_table(value) {
      if (value !== null) {
        const diff = value.split("-");
        const day = diff[2];
        const month = diff[1];
        const year = parseInt(diff[0]);
        return day + "-" + month + "-" + year;
      } else {
        let result = this.min_date();
        const diff = result.split("-");
        const day = diff[2];
        const month = diff[1];
        const year = parseInt(diff[0]);
        return day + "-" + month + "-" + year;
      }
    },
    diffDateTH(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "-" + month + "-" + year;
      return (this.send_po_receipt.po_date = final_date);
    },
    diffDateEN() {
      const diff = this.dateEN.split("-");
      const year = parseInt(diff[2]) - 543;
      const month = diff[1];
      const day = diff[0];
      return year + "-" + month + "-" + day;
    },
    diffDueDateTH(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "-" + month + "-" + year;
      return (this.send_po_receipt.date_credit = final_date);
    },
    diffDueDateEN() {
      const diff = this.dateDueEN.split("-");
      const year = parseInt(diff[2]) - 543;
      const month = diff[1];
      const day = diff[0];
      return year + "-" + month + "-" + day;
    },
    format_price: function (value) {
      return formatPrice(value);
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt);
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number);
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    min_date: function () {
      return minDate();
    },
    // getProductList() {
    //   HTTP.post("/purchaseorders/products").then((res) => {
    //     if (res.data.success === true) {
    //       this.product_list = res.data.products;
    //     }
    //   });
    // },

    getDocNumberPreview() {
      HTTP.post('imports/generate-doc-number').then(res => {
        if (res.data.success) {
          this.send_po_receipt.doc_number = res.data.doc_number;
        }
      });
    },

    getPO() {
      this.loading_page = true;
      HTTP.post("/purchaseorders/getpoall2").then((res) => {
        if (res.data.success === true) {
          this.loading_page = false;
          this.po_lists = res.data.object;
        }
      });
    },
    getPO_lists(po_id) {
      this.$store.commit("temp_data_clear");
      this.data_list = [];
      HTTP.post("/purchaseorders/getpolists", {
        po_id: po_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.send_po_receipt.supplier_id = res.data.object.po.supplier_id;
          this.send_po_receipt.supplier_name = res.data.object.po.supplier_name;
          this.send_po_receipt.discount_last_percent =
            res.data.object.po.discount_percent;
          this.send_po_receipt.discount_last_price =
            res.data.object.po.discount_bill;
          this.send_po_receipt.type_vat = res.data.object.po.type_vat;
          this.send_po_receipt.po_type = res.data.object.po.po_type;
          this.po_data_list = res.data.object.po_lists;
        }

        this.po_data_list.forEach((data) => {
          const id = (this.loop_id += 1);
          if (data.qty_balance != 0) {
            this.data_list.push({
              loop_id: id,
              po_lists_id: data.id,
              product_id: data.product_id,
              product_code: data.product_code,
              product_lot: null,
              product_name: data.product_name,
              units: data.units,
              unit_id: data.unit_id,
              date_exp: this.date_table(this.min_date()),
              // date_exp: data.date_exp,
              default_qty: data.qty_balance,
              qty: data.qty_balance,
              price: data.price,
              discount_unit_price: data.discount_unit,
              discount_unit_percent: data.discount,
              total: data.total,
              total_price: 0,
              status_return: false,
            });
          }
        });

        this.loading_product = true;
        HTTP.post("/suppliers/getproducts", {
          supplier_id: res.data.object.po.supplier_id,
        }).then((res) => {
          if (res.data.success === true) {
            this.loading_product = false;
            this.product_list = res.data.object;
          }
        });

        this.alert_success = true;
        setTimeout(() => (this.alert_success = false), 3000);
      });
    },
    async add_product(pro_id) {
      await HTTP.post("/purchaseorders/getsupsandunits", {
        product_id: pro_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.product_lists = res.data.product_lists;
        }
      });

      let value = this.product_list.filter((res) => {
        return res.product_id == pro_id;
      });
      value.forEach((details) => {
        const id = (this.loop_id += 1);
        this.data_list.push({
          loop_id: id,
          po_lists_id: null,
          product_id: details.product_id,
          product_code: details.product_code,
          product_lot: null,
          product_name: details.name,
          units: this.product_lists,
          unit_id: null,
          date_exp: this.min_date(),
          default_qty: null,
          qty: null,
          cost: 0,
          total: 0,
          price: null,
          discount_unit_price: null,
          discount_unit_percent: null,
          total_price: 0,
          status_return: false,
          is_delete: details.is_delete,
        });
      });
      await this.$nextTick(() => {
        this.send_po_receipt.pro_id = pro_id;
        this.alert_success = true;
        setTimeout(() => (this.alert_success = false), 5000);
      });
    },
    async getSupplier() {
      await HTTP.post('/suppliers/all')
        .then((res) => {
          if (res.data.success === true) {
            this.supplierType = res.data.object.map((obj) => {
              return {
                id: obj.id,
                name: obj.department !== '-' && obj.department !== null ? obj.name + ' (' + obj.department + ')' : obj.name,
              }
            });
          }
        })
    },
    async create_po() {
      // ไม่เช็ค form validation ก่อน แต่เช็คว่ามีข้อมูลพื้นฐานหรือไม่
      if (this.data_list.length === 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "กรุณาเพิ่มรายการสินค้าก่อนบันทึก",
          icon: "error",
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      // กรองเฉพาะรายการที่กรอกล็อต
      const itemsWithLot = this.data_list.filter(item => {
        return item.product_lot && item.product_lot.trim() !== '';
      });

      // ถ้าไม่มีรายการที่กรอกล็อตเลย
      if (itemsWithLot.length === 0) {
        Swal.fire({
          title: 'ไม่มีรายการที่กรอกล็อต!',
          text: 'กรุณากรอก LOT และ วันที่หมดอายุ อย่างน้อย 1 รายการ',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      // ตรวจสอบรายการที่กรอกล็อต ว่าข้อมูลครบหรือไม่
      let invalidLotItems = [];
      itemsWithLot.forEach((item) => {
        const errors = [];

        if (!item.unit_id) {
          errors.push('หน่วยนับ');
        }
        if (!item.date_exp || item.date_exp === '') {
          errors.push('วันหมดอายุ');
        }
        if (!item.qty || parseFloat(item.qty) <= 0) {
          errors.push('จำนวนที่ได้รับ');
        }
        if (item.price == null || item.price === '' || item.price === undefined) {
          errors.push('ราคาต่อหน่วย');
        }

        if (errors.length > 0) {
          invalidLotItems.push({
            index: this.data_list.indexOf(item) + 1,
            product_name: item.product_name,
            lot: item.product_lot,
            missing: errors.join(', ')
          });
        }
      });

      // ถ้ามีรายการที่กรอกล็อตไม่ครบ แสดง error
      if (invalidLotItems.length > 0) {
        let errorMessage = 'รายการที่กรอกล็อตแล้วต้องกรอกข้อมูลให้ครบ:\n\n';
        invalidLotItems.forEach(item => {
          errorMessage += `รายการที่ ${item.index}: ${item.product_name} (ล็อต: ${item.lot})\n`;
          errorMessage += `  → ขาด: ${item.missing}\n\n`;
        });

        Swal.fire({
          title: 'ไม่สามารถบันทึกได้!',
          html: errorMessage.replace(/\n/g, '<br>'),
          icon: 'error',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      // ตรวจสอบ form validation ของข้อมูลหลัก (PO, วันที่, ฯลฯ)
      if (!this.$refs.po_list.validate()) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "กรุณากรอกข้อมูลส่วนหัวให้ครบถ้วน",
          icon: "error",
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      // คำนวณข้อมูลสำหรับรายการที่กรอกล็อต
      itemsWithLot.forEach((datalist, index) => {
        let item = datalist.units.find((detail) => {
          return detail.unit_id == datalist.unit_id;
        });
        itemsWithLot[index].sub_qty = item.unit_qty * datalist.qty;
        itemsWithLot[index].cost =
          parseFloat(datalist.total_price) /
          (parseInt(item.unit_qty) * parseInt(datalist.qty));
      });

      let duplicateIndices = [];
      itemsWithLot.forEach((element, index) => {
        const firstIndex = itemsWithLot.findIndex(
          (e, i) => i !== index && e.product_id === element.product_id
        );
        if (firstIndex !== -1) {
          duplicateIndices.push(element);
        }
      });

      let qty_arr = [];
      let total_arr = [];
      let product_id = [];
      let checkcost = {};

      itemsWithLot.forEach(async (items) => {
        let item = null;
        let check_product_id = await product_id.find((o) => o == items.product_id)
        if (check_product_id == null) {
          total_arr.push({ id: items.product_id, total: 0 });
          qty_arr.push({ id: items.product_id, qty: 0 });
          product_id.push(items.product_id);
        }

        item = items.units.find((detail) => {
          return items.unit_id == detail.unit_id;
        });

        let qtyObj = qty_arr.find(o => o.id === items.product_id);
        if (qtyObj) {
          qtyObj.qty += parseInt(items.qty * item.unit_qty)
        }

        let totalObj = total_arr.find(o => o.id === items.product_id);
        totalObj.price = 200
        if (totalObj) {
          totalObj.total += parseFloat(items.total_price)
        }

        checkcost = itemsWithLot.filter(
          (res) => res.product_id === items.product_id
        );
        checkcost.forEach((details) => {
          details.cost = totalObj.total / qtyObj.qty;
        });
      });

      let data = {
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
        po_id: this.send_po_receipt.po_lists_id,
        receipt_number: this.send_po_receipt.receipt,
        supplier_name: this.send_po_receipt.supplier_name,
        note: this.send_po_receipt.note,
        po_date: this.dateEN,
        credit_date: this.dateDueEN,
        is_credit: this.send_po_receipt.po_type,
        type_vat: this.send_po_receipt.type_vat,
        discount_last_percent: this.send_po_receipt.discount_last_percent,
        discount_last_price: this.send_po_receipt.discount_last_price,
        doc_number: this.send_po_receipt.doc_number,
        total_no_vat: parseFloat(
          this.send_po_receipt.product_no_vat.replace(/,/g, "")
        ),
        vat: parseFloat(
          this.send_po_receipt.product_add_vat.replace(/,/g, "")
        ),
        grand_total: parseFloat(
          this.send_po_receipt.grand_total.replace(/,/g, "")
        ),
        po_lists: await itemsWithLot, // ส่งเฉพาะรายการที่กรอกล็อต
      }

      this.overlay = true;
      this.test = itemsWithLot

      HTTP.post('/imports/importbypo', data).then((res) => {
        if (res.data.success === true) {
          this.overlay = false;
          Swal.fire("บันทึกข้อมูลเรียบร้อย", "", "success").then(() => {
            this.$router.push("/stock/storage/addproducttostock");
          });
        } else {
          this.overlay = false;
          Swal.fire({
            title: "กรุณาตรวจสอบจำนวนให้ตรงกับใบสั่งซื้อ",
            text: res.data.message,
            icon: "error",
            confirmButtonText: 'ตกลง'
          });
        }
      }).catch((error) => {
        this.overlay = false;
        Swal.fire({
          title: 'เกิดข้อผิดพลาด!',
          text: error.message || 'ไม่สามารถบันทึกข้อมูลได้',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        });
      });
    },
    getDelete(loop_id, po_lists_id) {
      Swal.fire({
        title: "คุณต้องลบข้อมูลหรือไม่ ?",
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          if (po_lists_id != null) {
            HTTP.post("/purchaseorders/deletepolist", {
              po_lists_id: po_lists_id,
            }).then(() => {
              this.alert_danger = true;
              setTimeout(() => (this.alert_danger = false), 2000);
              this.data_list = this.data_list.filter(
                (detail) => detail.loop_id !== loop_id
              );
            });
          } else {
            this.alert_danger = true;
            setTimeout(() => (this.alert_danger = false), 2000);
            this.data_list = this.data_list.filter(
              (detail) => detail.loop_id !== loop_id
            );
          }
        }
      });
    },
  },
  computed: {
    total() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum, number) => {
      //   let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //   if (total_price < 0) {
      //     return sum+(0);
      //   }
      //   else {
      //     return sum+(total_price);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        return sum + number.total_price;
      }, 0);
      return result
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.send_po_receipt.type_vat == 0){
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let in_vat = ((total_price * 7)/107);
      //     let total_grand = total_price - in_vat
      //     if (total_grand < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+(total_grand);
      //     }
      //   }
      //   else if(this.send_po_receipt.type_vat == 1) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      //   else if(this.send_po_receipt.type_vat == 2) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      //   else if(this.send_po_receipt.type_vat == 3) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let discount_percent = this.send_po_receipt.discount_last_percent;
      let discount_unit = this.send_po_receipt.discount_last_price;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total_price;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.send_po_receipt.type_vat == 0) {
        let before_vat = total_discount * (100 / 107);
        return before_vat
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return total_discount
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    cal_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.send_po_receipt.type_vat == 0) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let calculate = ((total_price * 7)/107);
      //     return sum+(calculate);
      //   }
      //   else if (this.send_po_receipt.type_vat == 1){
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let calculate = (total_price * (7/100));
      //     return sum+(calculate);
      //   }
      //   else if (this.send_po_receipt.type_vat == 2){
      //     return sum+(0);
      //   }
      //   else if (this.send_po_receipt.type_vat == 3){
      //     return sum+(0);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let discount_percent = this.send_po_receipt.discount_last_percent;
      let discount_unit = this.send_po_receipt.discount_last_price;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total_price;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.send_po_receipt.type_vat == 0) {
        let result_vat = total_discount * (7 / 107);
        return result_vat
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (this.send_po_receipt.type_vat == 1) {
        let result_vat = total_discount * (7 / 100);
        return result_vat
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        let zero = 0;
        return zero
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    total_all() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.send_po_receipt.type_vat == 0){
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      //   else if(this.send_po_receipt.type_vat == 1) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let ex_vat = ((total_price * 7)/100);
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price + ex_vat);
      //     }
      //   }
      //   else if(this.send_po_receipt.type_vat == 2) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      //   else if(this.send_po_receipt.type_vat == 3) {
      //     let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      // }, 0)
      // return result;
      let total_discount = 0;
      let sum_vat = 0;

      let discount_percent = this.send_po_receipt.discount_last_percent;
      let discount_unit = this.send_po_receipt.discount_last_price;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total_price;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      if (this.send_po_receipt.type_vat == 1) {
        sum_vat = total_percent - discount_unit;
        total_discount = sum_vat * (7 / 100) + sum_vat;
      } else {
        total_discount = total_percent - discount_unit;
      }

      return total_discount
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.getPO();
    this.getSupplier();
    this.getDocNumberPreview();
    // this.getProductList();
  },
  created() {
    this.cache_page();
  },
};
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}

.grid_row {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}

.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_product {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.v-input__slot {
  align-items: center !important;
  justify-content: center !important;
  padding-top: 10px !important;
}

.input_style>>>input {
  border: #9e9e9e solid 1px !important;
  transition: 0.2s !important;
  font-size: 18px !important;
  color: black !important;
  padding: 27px !important;
  padding-left: 12px !important;
}

.input_style>>>input:hover {
  border-color: black !important;
}

.input_style>>>input:focus {
  border-color: #8cc63e !important;
}

.d_flex {
  display: flex;
}

.width_mobile {
  width: 30%;
}

@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_product {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .d_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .width_mobile {
    margin: 0 !important;
    width: 100%;
  }
}
</style>
